// extracted by mini-css-extract-plugin
module.exports = {"toggle":"_1ytcTRG4v_R1cN-PJFiy8V"};